import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  AntSwitch,
  Colors,
  FindLoad,
  Images,
  PermissionsList,
  RolePermission,
  useGlobalText,
  userType,
} from 'utils';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@material-ui/core';
import { Circle, DocumentTable, EditSaveButtons, Line, MinLoader } from 'components';
import { EditCarrierInputs } from '../../createCarrier';
import { Access } from './access';
import { carrierInfoFragments, PaymentSetup } from './index';
import { Blacklist } from './blacklist';
import { carrierActions, rmisActions } from 'store';
import { carrierIntegrationEnums, highwayConStatusStepsList, RenderDetails } from './constants';
import { CARRIER_DOCK_STATUSES } from '../../../../pages/carriers';
import { WNine } from './wNine';
import { vendorEnums } from 'pages';
import { RadioButtons } from '../../createCarrier/core/radioButtons';
import { InsuranceInfo } from './insuranceInfo';
import { SafetyCompliance } from './safetyCompliance';
import { renderGoHighwayInfoStatus2 } from '../../createCarrier/core/constants';
import { GoHighwayStatusesSteps } from './goHighwayStatusesSteps';

const INTEGRATION_ACTION_TYPE = 'EDIT_CARRIER_SETTINGS';
export const CarrierInfoTable = ({ info, handleChangeName }) => {
  const { carrierById } = useSelector((state) => ({
      carrierById: state.carriers.carrierById,
    }),
  );
  const globalStyle = useGlobalText();
  const classes = carrierInfoFragments();
  const dispatch = useDispatch();
  const loader = FindLoad('REFRESH_RMIS');
  // const [switchBoolean, setSwitchBoolean] = useState(false);
  const [doNot, setDoNot] = useState('INACTIVE');
  const [feeExempt, setFeeExempt] = useState(false);
  const [ownRisk, setOwnRisk] = useState(false);
  const history = useHistory();
  const pushInfo = history?.location?.state;
  const carrierInfo = RenderDetails(pushInfo?.vendorType || carrierById?.type);
  const [integration, setIntegration] = useState('');
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    if (info) {
      // setSwitchBoolean(info?.rmisRequired);
      setDoNot(carrierById?.doNotLoad === true ? 'ACTIVE' : 'INACTIVE');
      setFeeExempt(carrierById?.feeExempt);
      setOwnRisk(carrierById?.riskCarrier);
      setIntegration(carrierById?.onboardingSource);
    }
  }, []);


  const handleAddDocument = (img) => {
    dispatch(carrierActions.addCarrierDocument(img, info.id));
  };

  const handleDeleteFile = (doc) => {
    dispatch(carrierActions.deleteCarrierDocument(info?.id, doc?.id));
  };

  const handleApprove = (doc, type) => {
    const params = {
      ...doc,
    };
    if (type !== 'edit') {
      params.status =
        type === 'deny' ? CARRIER_DOCK_STATUSES.INACTIVE :
          type === 'approve' ? CARRIER_DOCK_STATUSES.ACTIVE :
            doc?.status === CARRIER_DOCK_STATUSES.PENDING ? CARRIER_DOCK_STATUSES.ACTIVE :
              doc?.status === CARRIER_DOCK_STATUSES.ACTIVE ? CARRIER_DOCK_STATUSES.INACTIVE :
                CARRIER_DOCK_STATUSES.ACTIVE;
    }
    dispatch(carrierActions.editCarrierDocument(info?.id, params));
  };


  const handleSync = () => {
    dispatch(rmisActions.refreshRMIS(info?.id, integration));
  };

  // const handleSetRequirements = () => {
  //   setSwitchBoolean(!switchBoolean);
  //   const body = {
  //     id: info?.id,
  //     required: !switchBoolean,
  //   };
  //   dispatch(rmisActions.requiredRMIS(body));
  // };

  const handleSetDoNot = () => {
    setDoNot(doNot === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE');
    dispatch(carrierActions.doNotLoad(info.id, doNot !== 'ACTIVE'));
  };

  const handleSetFeeExempt = () => {
    setFeeExempt(!feeExempt);
    dispatch(carrierActions.feeExempt(info.id, !feeExempt));
  };

  const handleOwnRisk = () => {
    setOwnRisk(!ownRisk);
    const params = {
      ...info,
    };
    params.riskCarrier = info.riskCarrier !== true;
    dispatch(carrierActions.editCarrier(info.id, params));
  };

  const handleCreate = () => {
    dispatch(carrierActions.editCarrierSettings(info.id, { onboardingSource: integration }));
  };

  const handleChancel = () => {
    setIntegration(carrierById?.onboardingSource);
    setDisabled(true);
  };

  return (
    <div className="accordion-style">
      <div className="action-settings-wrapper" style={{ marginBottom: 16 }}>
        <div className="settings-icon-title">
          <img src={Images.settings} alt="icon" />
          <p>Settings</p>
        </div>
        <div className="setting-flex">
          <div className="setting-flex right">
            <span className="setting-title">{'Load At Your Own Risk'}</span>
            <AntSwitch
              disabled={!RolePermission([PermissionsList.CARRIER_STATUS?.code])}
              onClick={handleOwnRisk}
              checked={ownRisk}
            />
          </div>
          <div className="setting-flex right">
            <span className="setting-title">{'Fee Exempt'}</span>
            <AntSwitch
              disabled={!RolePermission([PermissionsList.CARRIER_STATUS?.code])}
              onClick={handleSetFeeExempt}
              checked={feeExempt}
            />
          </div>
          <div className="setting-flex">
            <span className="setting-title">{'Do Not Load'}</span>
            <AntSwitch
              disabled={!RolePermission([PermissionsList.CARRIER_STATUS?.code])}
              onClick={handleSetDoNot}
              checked={doNot === 'ACTIVE'}
            />
          </div>
        </div>
      </div>
      {(info?.type === vendorEnums.CARRIER && info?.onboardingSource === carrierIntegrationEnums.GO_HIGHWAY) &&
        <div
          className="action-settings-wrapper"
          style={{ height: 'auto', justifyContent: 'flex-end', gap: 16, padding: '14px 16px' }}
        >
          <div className="settings-icon-title" style={{ margin: '0 auto 0 0' }}>
            <p style={{ margin: 0 }}>Authority Statuses</p>
          </div>

          <div className="carrier-info-statuses-wrapper">
            <p className="carrier-info-statuses-text" style={{ fontWeight: 700 }}>Common:</p>
            <p className="carrier-info-statuses-text">
              {renderGoHighwayInfoStatus2(info?.commonAuthStatus).text}
            </p>
            {renderGoHighwayInfoStatus2(info?.commonAuthStatus)?.Icon &&
              <div
                className="carrier-info-statuses-icon"
                style={{
                  backgroundColor: renderGoHighwayInfoStatus2(info?.commonAuthStatus).text === 'Active' ? '#ECFDF3' : '#FEEBF0',
                }}
              >
                <img src={renderGoHighwayInfoStatus2(info?.commonAuthStatus)?.Icon} alt="checkmark" />
              </div>
            }
          </div>

          <div className="carrier-info-statuses-wrapper">
            <p className="carrier-info-statuses-text" style={{ fontWeight: 700 }}>Contract:</p>
            <p className="carrier-info-statuses-text">
              {renderGoHighwayInfoStatus2(info?.contractAuthStatus).text}
            </p>
            {renderGoHighwayInfoStatus2(info?.contractAuthStatus)?.Icon &&
              <div
                className="carrier-info-statuses-icon"
                style={{
                  backgroundColor: renderGoHighwayInfoStatus2(info?.contractAuthStatus).text === 'Active' ? '#ECFDF3' : '#FEEBF0',
                }}
              >
                <img src={renderGoHighwayInfoStatus2(info?.contractAuthStatus)?.Icon} alt="checkmark" />
              </div>
            }
          </div>

          <div className="carrier-info-statuses-wrapper">
            <p className="carrier-info-statuses-text" style={{ fontWeight: 700 }}>Broker:</p>
            <p className="carrier-info-statuses-text">
              {renderGoHighwayInfoStatus2(info?.brokerAuthStatus).text}
            </p>
            {renderGoHighwayInfoStatus2(info?.brokerAuthStatus)?.Icon &&
              <div
                className="carrier-info-statuses-icon"
                style={{
                  backgroundColor: renderGoHighwayInfoStatus2(info?.brokerAuthStatus).text === 'Active' ? '#ECFDF3' : '#FEEBF0',
                }}
              >
                <img src={renderGoHighwayInfoStatus2(info?.brokerAuthStatus)?.Icon} alt="checkmark" />
              </div>
            }
          </div>

          <div className="carrier-info-statuses-wrapper">
            <p className="carrier-info-statuses-text" style={{ fontWeight: 700 }}>Interstate:</p>
            <p className="carrier-info-statuses-text">
              {renderGoHighwayInfoStatus2(info?.interstateAuthStatus).text}
            </p>
            {renderGoHighwayInfoStatus2(info?.interstateAuthStatus)?.Icon &&
              <div
                className="carrier-info-statuses-icon"
                style={{
                  backgroundColor: renderGoHighwayInfoStatus2(info?.interstateAuthStatus).text === 'Active' ? '#ECFDF3' : '#FEEBF0',
                }}
              >
                <img src={renderGoHighwayInfoStatus2(info?.interstateAuthStatus)?.Icon} alt="checkmark" />
              </div>
            }
          </div>

          <div className="carrier-info-statuses-wrapper">
            <p className="carrier-info-statuses-text" style={{ fontWeight: 700 }}>Operating Status:</p>
            <p className="carrier-info-statuses-text">
              {info?.operatingStatus || 'N/A'}
            </p>
          </div>
        </div>
      }

      {((userType === 'ADMIN' && !info?.isFactored && pushInfo?.vendorType === vendorEnums.CARRIER)
        ||
        (info?.type === vendorEnums.CARRIER && info?.onboardingSource === carrierIntegrationEnums.GO_HIGHWAY)
      ) && (
        <div className={classes.rmisActionsWrapper} style={{ flexDirection: 'column', gap: 16 }}>
          {(userType === 'ADMIN' && !info?.isFactored && pushInfo?.vendorType === vendorEnums.CARRIER) &&
            <div
              className={classes.rmisActionsWrapper}
              style={{ backgroundColor: 'transparent', borderRadius: 0, marginBottom: 0, padding: 0 }}
            >
              <div className={classes.rmisIconWrapper} style={{ gap: 8 }}>
                {(info?.onboardingSource === carrierIntegrationEnums.RMIS || info?.onboardingSource === carrierIntegrationEnums.GO_HIGHWAY) &&
                  <img
                    style={{ width: '42px', height: '42px' }}
                    src={
                      info?.onboardingStatus === 'INACTIVE' ?
                        info?.onboardingSource === carrierIntegrationEnums.RMIS ? Images.rmisInactive : Images.highwayInactive
                        :
                        info?.onboardingSource === carrierIntegrationEnums.RMIS ? Images.rmisActive : Images.highway
                    }
                    alt={'icon'}
                  />
                }
                <p
                  style={{
                    color: info?.rmisStatus === 'INACTIVE' ? '#9C9EA9' : '#2A374E',
                  }}
                >
                  Integrations
                </p>
              </div>
              <div className={classes.rmisSettings}>
                <div className="flex-align-center">
                  <div className={classes.integrationChoice}>
                    <RadioButtons
                      handleSelect={() => !disabled && setIntegration(carrierIntegrationEnums?.RMIS)}
                      one={true}
                      check={integration === carrierIntegrationEnums?.RMIS}
                      label={'RMIS'}
                      radioColor={'#FFC107'}
                      disabled={disabled}
                    />
                    <div className={classes.integrationChoiceLine} />
                    <RadioButtons
                      handleSelect={() => !disabled && setIntegration(carrierIntegrationEnums?.GO_HIGHWAY)}
                      one={true}
                      check={integration === carrierIntegrationEnums?.GO_HIGHWAY}
                      label={'GoHighway'}
                      radioColor={'#FFC107'}
                      disabled={disabled}
                    />
                    <div className={classes.integrationChoiceLine} />
                    <RadioButtons
                      handleSelect={() => !disabled && setIntegration(carrierIntegrationEnums?.NONE)}
                      one={true}
                      check={integration === carrierIntegrationEnums?.NONE}
                      label={'None'}
                      radioColor={'#FFC107'}
                      disabled={disabled}
                    />
                  </div>

                  <div style={{ position: 'relative', marginLeft: 20 }}>
                    <EditSaveButtons
                      type={INTEGRATION_ACTION_TYPE}
                      handleChancel={handleChancel}
                      handleSetEdit={() => setDisabled(false)}
                      handleSaveInfo={handleCreate}
                      afterSuccess={() => setDisabled(true)}
                    />
                  </div>
                </div>

                {/*<div className={classes.requireRmis}>*/}
                {/*  <p>Require RMIS</p>*/}
                {/*  <AntSwitch*/}
                {/*    onClick={handleSetRequirements}*/}
                {/*    checked={switchBoolean}*/}
                {/*  />*/}
                {/*</div>*/}
                {info?.onboardingSource !== carrierIntegrationEnums.NONE &&
                  <button onClick={handleSync} className={classes.rmisSync}>
                    {loader?.length ? (
                      <MinLoader
                        position={'relative'}
                        margin={'0'}
                        color={Colors.ThemeBlue}
                      />
                    ) : (
                      'Sync'
                      // 'RMIS Sync'
                    )}
                  </button>
                }
              </div>
            </div>
          }

          {(info?.type === vendorEnums.CARRIER
              &&
              info?.onboardingSource === carrierIntegrationEnums.GO_HIGHWAY
              &&
              carrierById?.highwayConStatus
            ) &&
            <GoHighwayStatusesSteps
              steps={highwayConStatusStepsList}
              status={carrierById?.highwayConStatus}
            />
          }
        </div>
      )}

      {carrierInfo?.Information &&
        <Accordion>
          <AccordionSummary
            className={'accordion'}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <div className="align-center">
              {info && <Circle number={carrierInfo?.Information?.number} back={Colors.TextPrimary} />}
              <p className={globalStyle.title}>
                {carrierInfo?.Information?.name}
              </p>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <EditCarrierInputs
              handleChangeName={handleChangeName}
              info={info}
            />
          </AccordionDetails>
        </Accordion>
      }

      {carrierInfo?.w9 &&
        <Accordion>
          <AccordionSummary
            className={'accordion'}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <div className="align-center">
              {info && <Circle number={carrierInfo?.w9?.number} back={Colors.TextPrimary} />}
              <p className={globalStyle.title}>{carrierInfo?.w9?.name}</p>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <WNine info={carrierById} />
          </AccordionDetails>
        </Accordion>
      }

      {carrierInfo?.payment && RolePermission([
        PermissionsList.ALL_ACCESS?.code,
        PermissionsList.CARRIER_PAYMENT_SETUP?.code,
      ]) && (
        <Accordion>
          <AccordionSummary
            className={'accordion'}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <div className="align-center">
              {info && <Circle number={carrierInfo?.payment?.number} back={Colors.TextPrimary} />}
              <p className={globalStyle.title}>{carrierInfo?.payment?.name}</p>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <PaymentSetup info={info} paymentInfo={carrierInfo?.payment} />
          </AccordionDetails>
        </Accordion>
      )}


      {RolePermission([
        PermissionsList.ALL_ACCESS?.code,
        PermissionsList.CREATE_UPDATE_CARRIER?.code,
      ]) && (
        <>
          {/*<Accordion>*/}
          {/*  <AccordionSummary*/}
          {/*    className={"accordion"}*/}
          {/*    expandIcon={<ExpandMoreIcon />}*/}
          {/*    aria-controls="panel1a-content"*/}
          {/*    id="panel1a-header"*/}
          {/*  >*/}
          {/*    <div className="align-center">*/}
          {/*      {info && <Circle number={3} back={Colors.TextPrimary} />}*/}
          {/*      <p className={globalStyle.title}>Equipment</p>*/}
          {/*    </div>*/}
          {/*  </AccordionSummary>*/}
          {/*  <AccordionDetails>*/}
          {/*    <Equipment />*/}
          {/*  </AccordionDetails>*/}
          {/*</Accordion>*/}

          {carrierInfo?.assignment &&
            <Accordion>
              <AccordionSummary
                className={'accordion'}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <div className="align-center">
                  {info && <Circle number={carrierInfo?.assignment?.number} back={Colors.TextPrimary} />}
                  <p className={globalStyle.title}>{carrierInfo?.assignment?.name}</p>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <Access />
              </AccordionDetails>
            </Accordion>
          }

          {carrierInfo?.access &&
            <Accordion>
              <AccordionSummary
                className={'accordion'}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <div className="align-center">
                  {info && <Circle number={carrierInfo?.access?.number} back={Colors.TextPrimary} />}
                  <p className={globalStyle.title}>{carrierInfo?.access?.name}</p>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <Blacklist />
              </AccordionDetails>
            </Accordion>
          }


          {carrierById?.type === vendorEnums.CARRIER && carrierById?.onboardingSource === carrierIntegrationEnums.GO_HIGHWAY &&
            <Accordion>
              <AccordionSummary
                className={'accordion'}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <div className="align-center">
                  {info && <Circle number={carrierInfo?.access?.number + 1} back={Colors.TextPrimary} />}
                  <p className={globalStyle.title}>Insurance Info</p>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="flex-align-start">
                  <Line height={'auto'} />
                  <div style={{ width: '100%' }}>
                    <InsuranceInfo />
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          }

          {carrierById?.type === vendorEnums.CARRIER && carrierById?.onboardingSource === carrierIntegrationEnums.GO_HIGHWAY &&
            <Accordion>
              <AccordionSummary
                className={'accordion'}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <div className="align-center">
                  {info && <Circle number={carrierInfo?.access?.number + 2} back={Colors.TextPrimary} />}
                  <p className={globalStyle.title}>Safety & Compliance</p>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="flex-align-start">
                  <Line height={'auto'} />
                  <div style={{ width: '100%' }}>
                    <SafetyCompliance />
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          }


          {carrierInfo?.documents &&
            <Accordion>
              <AccordionSummary
                className={'accordion'}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <div className="align-center">
                  {info && <Circle number={carrierInfo?.documents?.number} back={Colors.TextPrimary} />}
                  <p className={globalStyle.title}>{carrierInfo?.documents?.name}</p>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="flex-align-start">
                  <Line height={'330px'} />
                  <div style={{ marginTop: '24px', width: '100%' }}>
                    <DocumentTable
                      allDocs={info?.documents}
                      documentsTypes={carrierInfo?.documents?.types}
                      handleChangeStatus={handleApprove}
                      changeStatusAction={'EDIT_CARRIER_DOCUMENT'}
                      deleteDocAction={'DELETE_CARRIER_DOCUMENT'}
                      handleDeleteDocument={handleDeleteFile}
                      addLoadAction={'ADD_CARRIER_DOCUMENT'}
                      handleUploadFile={handleAddDocument}
                      permissionForDelete={PermissionsList.CREATE_UPDATE_CARRIER?.code}
                      allowSwitchStatus
                    />
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          }
        </>
      )}
    </div>
  );
};
